<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        Show
        <select
          class="custom-select"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
      <div class="col-md-6 text-right">
        <button
          v-if="role == 'admin' || (role == 'employee' && isEnrolmentOpen) || (role == 'employee' && isNewEmployee)"
          class="btn add-btn"
          @click="$router.push({ name: 'insuranceDependentInsuranceAdd' })"
        >
          <i class="fa fa-plus"></i>New Insurance
        </button>
      </div>
    </div>

    <!-- Begin: Popover for Filter -->
    <div>
      <popover
        name="popEmployeeInsurance"
        :pointer="false"
        style="width: 30em; margin-left: -5em"
      >
        <multiselect
          v-model="searchColFilter.tranEmployee"
          :options="colFilter.tranEmployeeColFilter"
          :multiple="true"
        ></multiselect>
      </popover>
      <popover
        name="popYearInsurance"
        :pointer="false"
        style="width: 30em; margin-left: -5em"
      >
        <multiselect
          v-model="searchColFilter.tranYear"
          :options="colFilter.tranYearColFilter"
          :multiple="true"
        ></multiselect>
      </popover>
      <popover
        name="popType"
        :pointer="false"
        style="width: 30em; margin-left: -5em"
      >
        <multiselect
          v-model="searchColFilter.tranType"
          :options="colFilter.tranTypeColFilter"
          :multiple="true"
        ></multiselect>
      </popover>
      <popover
        name="popCategory"
        :pointer="false"
        style="width: 30em; margin-left: -5em"
      >
        <multiselect
          v-model="searchColFilter.tranCategory"
          :options="colFilter.tranCategoryColFilter"
          :multiple="true"
        ></multiselect>
      </popover>
      <popover
        name="popChildren"
        :pointer="false"
        style="width: 30em; margin-left: -5em"
      >
        <multiselect
          v-model="searchColFilter.tranChildren"
          :options="colFilter.tranChildrenColFilter"
          :multiple="true"
        ></multiselect>
      </popover>
      <popover
        name="popCurrency"
        :pointer="false"
        style="width: 30em; margin-left: -10em"
      >
        <multiselect
          v-model="searchColFilter.tranCurrency"
          :options="colFilter.tranCurrencyColFilter"
          :multiple="true"
        ></multiselect>
      </popover>
      <popover
        name="popAmount"
        :pointer="false"
        style="width: 30em; margin-left: -10em"
      >
        <multiselect
          v-model="searchColFilter.tranAmount"
          :options="colFilter.tranAmountColFilter"
          :multiple="true"
        ></multiselect>
      </popover>
    </div>
    <!--End: Popover for Filter-->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th
                  v-if="
                    role == 'admin' || (role == 'employee' && isEnrolmentOpen) || (role == 'employee' && isNewEmployee)
                  "
                  class="text-center action-column"
                >
                  Action
                </th>
                <th v-if="role == 'admin'">
                  <i
                    class="fa fa-filter"
                    v-popover:popEmployeeInsurance
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranEmployee.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('employee')">
                    Employee Name (Emp ID)
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'employee'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'employee_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popYearInsurance
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranYear.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('year')">
                    Insurance Year
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'year'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'year_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popType
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranType.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('type')">
                    Type of Insurance
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'type'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'type_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popCategory
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranCategory.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('category')">
                    Enrolment Category
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'category'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'category_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popChildren
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranChildren.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('children')">
                    No. Of Children
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'children'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'children_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popCurrency
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranCurrency.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('currency')">
                    Currency
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'currency'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'currency_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popAmount
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranAmount.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('amount')">
                    Amount
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'amount'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'amount_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in insurances" :key="item.Id">
                <td
                  v-if="
                    role == 'admin' || (role == 'employee' && isEnrolmentOpen) || (role == 'employee' && isNewEmployee)
                  "
                >
                  <router-link
                    v-if="
                      role == 'admin' ||
                      (role == 'employee' && item.IsChangeAllowForEmployee) || 
                      (role == 'employee' && isNewEmployee)
                    "
                    class="btn"
                    title="Edit"
                    :to="{
                      name: 'insuranceDependentInsuranceEdit',
                      params: { id: item.Id },
                    }"
                  >
                    <i class="fa fa-edit"></i>
                  </router-link>
                  <button
                    v-if="
                      role == 'admin' ||
                      (role == 'employee' && item.IsChangeAllowForEmployee) ||
                      (role == 'employee' && isNewEmployee)
                    "
                    class="btn"
                    title="Delete"
                    @click="remove(item.Id)"
                  >
                    <i class="fa fa-trash-o"></i>
                  </button>
                </td>
                <td v-if="role == 'admin'">{{ item.Employee }}</td>
                <td>{{ item.YearDisplay }}</td>
                <td>{{ item.InsuranceType }}</td>
                <td>{{ item.EnrolmentCategory }}</td>
                <td>{{ item.NumberOfChildrenDisplay }}</td>
                <td>{{ item.Currency }}</td>
                <td>{{ item.AmountDisplay }}</td>
              </tr>
              <tr v-if="insurances && !insurances.length">
                <td
                  :colspan="
                    role == 'admin'
                      ? '8'
                      : role == 'employee' && (isEnrolmentOpen || isNewEmployee)
                      ? '7'
                      : '6'
                  "
                  class="text-center"
                >
                  {{ this.noRecordText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row" v-if="insurances && insurances.length">
      <div class="col-md-6 col-lg-6 col-sm-6 my-auto text-lg-left text-center">
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          insurances.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import Multiselect from "vue-multiselect";
import config from "../../../config.js";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      insurances: null,
      isEnrolmentOpen: false,
      isNewEmployee: false,
      noRecordText: config.NO_RECORD_TEXT,
      //for pagination
      searchColFilter: {
        tranEmployee: [],
        tranYear: [],
        tranType: [],
        tranCategory: [],
        tranChildren: [],
        tranCurrency: [],
        tranAmount: [],
      },
      colFilter: {},
      paging: {
        Search: "",
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 5,
        Sizes: [5, 10, 20, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
    searchFilter() {
      return [
        { name: "tranEmployee", val: this.searchColFilter.tranEmployee },
        { name: "tranYear", val: this.searchColFilter.tranYear },
        { name: "tranType", val: this.searchColFilter.tranType },
        { name: "tranCategory", val: this.searchColFilter.tranCategory },
        { name: "tranChildren", val: this.searchColFilter.tranChildren },
        { name: "tranCurrency", val: this.searchColFilter.tranCurrency },
        { name: "tranAmount", val: this.searchColFilter.tranAmount },
      ];
    },
  },

  watch: {
    "searchColFilter.tranEmployee": function (val, oldVal) {
      this.getEmployeeInsurances();
    },
    "searchColFilter.tranYear": function (val, oldVal) {
      this.getEmployeeInsurances();
    },
    "searchColFilter.tranType": function (val, oldVal) {
      this.getEmployeeInsurances();
    },
    "searchColFilter.tranCategory": function (val, oldVal) {
      this.getEmployeeInsurances();
    },
    "searchColFilter.tranChildren": function (val, oldVal) {
      this.getEmployeeInsurances();
    },
    "searchColFilter.tranCurrency": function (val, oldVal) {
      this.getEmployeeInsurances();
    },
    "searchColFilter.tranAmount": function (val, oldVal) {
      this.getEmployeeInsurances();
    },
    "paging.Search": function (val, oldVal) {
      this.getEmployeeInsurances();
    },
    "paging.SizePerPage": function (val, oldVal) {
      this.paging.CurrentPage = 1;
      this.getEmployeeInsurances();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },

  methods: {
    remove(id) {
      let param = {
        Token: this.token,
        Id: id,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to delete the record?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willDelete) => {
        if (willDelete) {
          this.$store.state.isLoading = true;
          API.deleteEmployeeInsurance(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.getEmployeeInsurances();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    getEmployeeInsurances() {
      let param = {
        Token: this.token,
        Search: this.paging.Search,
        CurrentPage: this.paging.CurrentPage,
        TotalPage: this.paging.TotalPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        searchFilter: this.searchFilter,
      };
      this.$store.state.isLoading = true;
      API.getEmployeeInsurance(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.insurances = response.data.record;
            this.isEnrolmentOpen = response.data.isEnrolmentOpen;
            this.isNewEmployee = response.data.isNewEmployee;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
            this.colFilter = response.data.colFilter;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },

    //pagination method
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getEmployeeInsurances();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getEmployeeInsurances();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getEmployeeInsurances();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getEmployeeInsurances();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getEmployeeInsurances();
    },
    setSortBy(payload) {
      switch (payload) {
        case "employee":
          if (this.paging.SortBy === "employee") {
            this.paging.SortBy = "employee_desc";
          } else if (this.paging.SortBy === "employee_desc") {
            this.paging.SortBy = "employee";
          } else {
            this.paging.SortBy = "employee";
          }
          break;
        case "year":
          if (this.paging.SortBy === "year") {
            this.paging.SortBy = "year_desc";
          } else if (this.paging.SortBy === "year_desc") {
            this.paging.SortBy = "year";
          } else {
            this.paging.SortBy = "year";
          }
          break;
        case "type":
          if (this.paging.SortBy === "type") {
            this.paging.SortBy = "type_desc";
          } else if (this.paging.SortBy === "type_desc") {
            this.paging.SortBy = "type";
          } else {
            this.paging.SortBy = "type";
          }
          break;
        case "category":
          if (this.paging.SortBy === "category") {
            this.paging.SortBy = "category_desc";
          } else if (this.paging.SortBy === "category_desc") {
            this.paging.SortBy = "category";
          } else {
            this.paging.SortBy = "category";
          }
          break;
        case "children":
          if (this.paging.SortBy === "children") {
            this.paging.SortBy = "children_desc";
          } else if (this.paging.SortBy === "children_desc") {
            this.paging.SortBy = "children";
          } else {
            this.paging.SortBy = "children";
          }
          break;
        case "currency":
          if (this.paging.SortBy === "currency") {
            this.paging.SortBy = "currency_desc";
          } else if (this.paging.SortBy === "currency_desc") {
            this.paging.SortBy = "currency";
          } else {
            this.paging.SortBy = "currency";
          }
          break;
        case "amount":
          if (this.paging.SortBy === "amount") {
            this.paging.SortBy = "amount_desc";
          } else if (this.paging.SortBy === "amount_desc") {
            this.paging.SortBy = "amount";
          } else {
            this.paging.SortBy = "amount";
          }
          break;
      }
      this.getEmployeeInsurances();
    },
  },

  created() {
    this.getEmployeeInsurances();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Insurance/InsuranceAndDependent/InsuranceList.vue